import {useNavigate, useParams} from 'react-router-dom';

const SaleAgents = () => {
  const navigate = useNavigate();
  const {brandId} = useParams();

  return (
    <div
      className="border shadow-sm p-3 rounded-xl mx-4 flex items-center justify-between"
      onClick={() => navigate(`/brand/${brandId}/sale-agents`)}
    >
      <div className="flex items-center gap-2">
        <div className="bg-gray-100 w-12 h-12 p-1 rounded-full flex items-center justify-center">
          <i className="icon-nameshops text-farm-shop-500 text-4xl" />
        </div>
        <span className="text-md text-gray-900">عاملین فروش</span>
      </div>

      <i className="icon-nameArrow---Left-2 text-2xl text-gray-900" />
    </div>
  );
};

export default SaleAgents;
